/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FAnonymousType145
 */
export interface FAnonymousType145 {
    /**
     * 
     * @type {number}
     * @memberof FAnonymousType145
     */
    score?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType145
     */
    comfortableMin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType145
     */
    comfortableMax?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType145
     */
    pitchMin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType145
     */
    pitchMax?: string | null;
}

/**
 * Check if a given object implements the FAnonymousType145 interface.
 */
export function instanceOfFAnonymousType145(value: object): value is FAnonymousType145 {
    return true;
}

export function FAnonymousType145FromJSON(json: any): FAnonymousType145 {
    return FAnonymousType145FromJSONTyped(json, false);
}

export function FAnonymousType145FromJSONTyped(json: any, ignoreDiscriminator: boolean): FAnonymousType145 {
    if (json == null) {
        return json;
    }
    return {
        
        'score': json['score'] == null ? undefined : json['score'],
        'comfortableMin': json['comfortableMin'] == null ? undefined : json['comfortableMin'],
        'comfortableMax': json['comfortableMax'] == null ? undefined : json['comfortableMax'],
        'pitchMin': json['pitchMin'] == null ? undefined : json['pitchMin'],
        'pitchMax': json['pitchMax'] == null ? undefined : json['pitchMax'],
    };
}

export function FAnonymousType145ToJSON(json: any): FAnonymousType145 {
    return FAnonymousType145ToJSONTyped(json, false);
}

export function FAnonymousType145ToJSONTyped(value?: FAnonymousType145 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'score': value['score'],
        'comfortableMin': value['comfortableMin'],
        'comfortableMax': value['comfortableMax'],
        'pitchMin': value['pitchMin'],
        'pitchMax': value['pitchMax'],
    };
}

